import React, { useState } from "react";
import styles from "./_css/popularExplore.module.css";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { KeyboardArrowDown } from "@material-ui/icons";
import { Collapse } from "@material-ui/core";
import { PopularEntryLink, PopularPurpose, PopularType, usePopularEntries } from "popular/popularLinks";

type Dropdown = {
    id: string;
    labelKey: string;
    type: PopularType;
    purpose: PopularPurpose;
};

const DROPDOWNS: Dropdown[] = [
    { id: "sale", labelKey: "footer.forSale", type: "location", purpose: "sale" },
    { id: "rent", labelKey: "footer.forRent", type: "location", purpose: "rent" },
    { id: "search", labelKey: "footer.popularSearches.title", type: "search", purpose: "sale" },
];

function ExploreDropdown({ dropdown, column }: { dropdown: Dropdown; column: number }) {
    const { t } = useTranslation();
    // Chaque menu s'ouvre/se ferme indépendamment des deux autres.
    const [open, setOpen] = useState(false);
    const entries = usePopularEntries(dropdown.type, dropdown.purpose);

    if (entries.length === 0) return null;

    return (
        <>
            {column !== 2 && <div className={styles.sep} style={{ gridColumn: column, gridRow: "1 / 3" }} />}
            <div className={styles.headerCell} style={{ gridColumn: column }}>
                <button
                    type={"button"}
                    className={styles.header}
                    aria-expanded={open}
                    onClick={() => setOpen((value) => !value)}
                >
                    <span className={styles.label}>{t(dropdown.labelKey)}</span>
                    <span className={clsx(styles.chevron, { [styles.chevronOpen]: open })}>
                        <KeyboardArrowDown />
                    </span>
                </button>
            </div>
            <div className={styles.bodyCell} style={{ gridColumn: column }}>
                <Collapse in={open}>
                    <div className={styles.body}>
                        {entries.map((entry, index) => (
                            <PopularEntryLink key={index} entry={entry} className={styles.link} />
                        ))}
                    </div>
                </Collapse>
            </div>
        </>
    );
}

export function PopularExplore() {
    const { t } = useTranslation();

    return (
        <section className={styles.explore}>
            <div className={styles.inner}>
                <div className={styles.grid}>
                    <div className={styles.titleBlock}>
                        <div className={styles.eyebrow}>{t("footer.exploreEyebrow")}</div>
                        <div className={styles.title}>
                            <span className={styles.titleBold}>{t("footer.exploreTitle")}</span>
                            <span className={styles.titleAccent}>{t("footer.exploreTitleAccent")}</span>
                        </div>
                    </div>
                    {DROPDOWNS.map((dropdown, index) => (
                        <ExploreDropdown key={dropdown.id} dropdown={dropdown} column={index + 2} />
                    ))}
                </div>
            </div>
        </section>
    );
}
